import styled from 'styled-components';
import { SummaryLegalTextStyled } from '@components/SummaryLegalText/SummaryLegalTextStyled';

export const SummaryLegalTextStyledAP = styled(SummaryLegalTextStyled)``;
